import React, {PropTypes} from 'react';
import './checkbox.less'

export default class Checkbox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value : this.props.status
    }
    this.changeHandler = this.changeHandler.bind(this);
  }
  changeHandler(e){
    this.setState({
      value : !this.state.value
    })
    this.props.handleChange(e.target.checked,this.props.id);
  }
  componentWillReceiveProps(nextProps){
    this.setState({
      value : nextProps.status
    })
  }
  render() {
    return (
      <div className="switch">
	        <input type="checkbox" checked={this.state.value} id={this.props.id} onChange={this.changeHandler}/>
	        <label htmlFor={this.props.id}></label>
      </div>
    )
  }
}

Checkbox.propTypes = {
  status : React.PropTypes.bool.isRequired,  //if the checkbox needs to be checked(true) or unchecked(false)
  changeHandler : React.PropTypes.func,      //this func called when the checkbox status is changed and it returns its value and id
  id : React.PropTypes.any.isRequired,       //unique id of the checkbox which will be retuned from changeHandler function
};



// WEBPACK FOOTER //
// app/components/checkbox/checkbox.jsx